import { Component } from 'react';
import { compose } from 'redux';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
// @ts-expect-error untyped module
import DSFilterEditor from 'customer-data-filters/components/DSFilterEditor';
// @ts-expect-error untyped module
import DSConnector from 'customer-data-filters/components/fetcher/DSConnector';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { wireCurrencyCode } from 'automation-ui-action-features/queries/currencyQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ClassicEnrollmentFilterViewer extends Component {
  renderMissingMessage(filters) {
    if (filters.size) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "edit.branchSection.noConditionsSet"
      })
    });
  }
  render() {
    const {
      filters,
      filterType,
      showCriteriaTitle,
      currencyCode,
      isUngated,
      hasScope,
      'data-test-id': dataTestId
    } = this.props;
    const flatFilters = filters.flatten(1);
    const filterLengths = filters.map(filter => filter.size);
    const numFilterGroups = filterLengths.size;
    const expandClass = numFilterGroups < 1 ? "hidden" : "";
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [showCriteriaTitle && /*#__PURE__*/_jsx("span", {
        className: "criteria-title",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: numFilterGroups ? `edit.${filterType}.label` : `edit.${filterType}.labelZero`
        })
      }), this.renderMissingMessage(filters), /*#__PURE__*/_jsx(UIExpandableText, {
        className: expandClass,
        expandButtonText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "edit.enrollmentNode.expandCriteria",
          options: {
            count: flatFilters.size
          }
        }),
        collapseButtonText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "edit.enrollmentNode.collapseCriteria"
        }),
        onExpandButtonClick: event => event.stopPropagation(),
        onCollapseButtonClick: event => event.stopPropagation(),
        maxHeight: 160,
        expandOnFocus: false,
        children: /*#__PURE__*/_jsx(DSConnector, {
          children: /*#__PURE__*/_jsx(DSFilterEditor, {
            value: filters.toJS(),
            currencyCode: currencyCode,
            onChange: emptyFunction,
            isReadOnly: true,
            getIsUngated: isUngated,
            hasScope: hasScope,
            "data-test-id": dataTestId
          })
        })
      })]
    });
  }
}
export default compose(wireAuthConsumer, wireCurrencyCode)(ClassicEnrollmentFilterViewer);